import { UseFormReturn } from "react-hook-form";
import SearchAddressForm from "@shared/components/application/form/search-address/SearchAddressForm/SearchAddressForm.web";
import { useTranslation } from "@shared/utils/internationalization";

export const FORM_ID = "checkout_shipping_address_form";

export default function CheckoutShippingAddressForm({
  form,
  id = FORM_ID,
  allowedCountries,
}: {
  form: UseFormReturn;
  id?: string;
  allowedCountries?: string[] | null;
}) {
  const { t } = useTranslation("common");

  return (
    <form data-testid={id} id={id}>
      <SearchAddressForm
        searchAriaLabel={t("Shipping address")}
        form={form}
        formId={id}
        isRequired
        titleProps={{
          fontWeight: 700,
          marginBottom: "6px",
        }}
        allowedCountries={allowedCountries}
      />
    </form>
  );
}
